<div class="summary">
  <div class="summary__title" *ngIf="title">{{ title }}</div>
  <div class="summary__items">
    <div class="item" *ngFor="let item of summary" [class.total]="item?.isTotal">
      <ng-container *ngIf="!item?.isInformative">
        <span class="name">{{ item.name }}</span>
        <div class="tooltip" *ngIf="item?.tooltip">
          <layout-tooltip
            [content]="TOOLTIP_CONTENT.SUMMARY_COMPONENT"
            [position]="ETOOLTIP_POSITION.ABOVE"
            [delay]="TOOLTIP_DELAY.THREE_SECONDS"
          ></layout-tooltip>
        </div>
        <div class="border-dashed"></div>
        <span class="value">
          {{ item.value }}
        </span>
      </ng-container>
      <ng-container *ngIf="item?.isInformative">
        <div class="item-informative">
          <p>{{ item.value }}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>
